<app-email-validation-card></app-email-validation-card>
<app-shared-root></app-shared-root>
